import { entryChips, heroStats, keywordTags } from "@/mocks/chigua";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-24 pb-10 md:pt-28">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="animate-rise">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-700">
            <i className="ri-bard-fill"></i>
            <span className="whitespace-nowrap">吃瓜福利新鲜出炉 · 每天更新别错过</span>
          </span>

          <h1 className="mt-5 text-4xl font-bold leading-[1.2] tracking-tight text-foreground-950 md:text-[54px]">
            吃瓜福利今日更新
            <br />
            <span className="text-primary-600">抢先看</span>，每日推荐
            <span className="relative inline-block">
              别错过
              <span className="absolute -bottom-1 left-0 h-2 w-full rounded-full bg-accent-200/70"></span>
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            在这里集中满足你追新瓜的需求——吃瓜福利今日更新、每日推荐、最新发布与实时更新一目了然，
            从舞台高光到网友热词，按热度与时间为你整理好入口，打开就能跟上进度。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-2">
            {keywordTags.map((tag) => (
              <span
                key={tag}
                className="flex items-center gap-1 rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-700 border border-background-200"
              >
                <i className="ri-hashtag text-accent-600"></i>
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#today"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              看今日更新
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#collections"
              className="inline-flex items-center gap-2 rounded-md bg-secondary-500 px-5 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-secondary-600"
            >
              <i className="ri-folder-open-fill"></i>
              逛专题合集
            </a>
          </div>

          <div className="mt-9 grid max-w-xl grid-cols-2 gap-3 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="rounded-lg bg-background-100 p-3 text-center border border-background-200">
                <div className="font-display text-2xl text-primary-600">{stat.value}</div>
                <div className="text-xs text-foreground-600">
                  {stat.label}
                  <span className="ml-0.5 text-foreground-400">{stat.unit}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative mx-auto hidden w-full max-w-md lg:block">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=portrait%20flat%20editorial%20vector%20illustration%20of%20a%20happy%20watermelon%20character%20surrounded%20by%20floating%20ticket%20notices%20star%20badges%20and%20breaking%20news%20cards%2C%20warm%20watermelon%20coral%20red%20and%20honey%20amber%20color%20palette%20over%20a%20soft%20cream%20canvas%20background%2C%20smooth%20rounded%20geometric%20shapes%2C%20playful%20modern%20minimal%20style%2C%20clean%20negative%20space%2C%20high%20detail%2C%20cohesive%20cinematic%20composition&width=640&height=760&seq=chigua-hero-main&orientation=portrait"
              alt="吃瓜福利今日更新入口"
              className="h-full w-full object-cover"
            />
          </div>

          <div className="animate-float absolute -left-5 top-8 flex items-center gap-2 rounded-lg bg-background-50/95 px-3 py-2 text-sm border border-background-200">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-flashlight-fill"></i>
            </span>
            <div>
              <div className="text-xs font-medium text-foreground-950">今日更新抢先看</div>
              <div className="text-[11px] text-primary-600">+86 篇热讯</div>
            </div>
          </div>

          <div className="absolute -bottom-4 -left-6 flex items-center gap-2 rounded-lg bg-background-50/95 px-3 py-2 text-sm border border-background-200">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-fire-fill"></i>
            </span>
            <div>
              <div className="text-xs font-medium text-foreground-950">实时热榜</div>
              <div className="text-[11px] text-foreground-600">刚刚刷新</div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 grid w-full max-w-7xl grid-cols-2 gap-2.5 px-4 md:grid-cols-3 lg:grid-cols-6 md:px-6">
        {entryChips.map((chip) => (
          <a
            key={chip.label}
            href={chip.href}
            className="group flex items-center justify-center gap-2 rounded-lg bg-background-100 px-3 py-3 text-sm text-foreground-800 border border-background-200 transition-colors hover:bg-accent-100 hover:text-accent-700"
          >
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className={`${chip.icon} text-xs`}></i>
            </span>
            <span className="whitespace-nowrap">{chip.label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}